module.exports = __webpack_public_path__ + "static/media/ten_monkeys_kitchen.c4df7314.gif";